module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "contextMenu",
    staticClass: "ctx-menu-container",
    style: (_vm.ctxStyle),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "contextmenu": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "ctx open",
    staticStyle: {
      "background-color": "transparent"
    }
  }, [_c('ul', {
    staticClass: "ctx-menu",
    class: {
      'ctx-menu-right': _vm.align === 'right',
        'ctx-menu-left': _vm.align === 'left'
    },
    attrs: {
      "role": "menu"
    }
  }, _vm._l((_vm.menuData), function(menu, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.show),
        expression: "menu.show"
      }],
      key: i,
      class: {
        'ctx-item': true, 'has-child': menu.hasChild, 'checked': menu.checked, 'disabled': menu.disabled
      },
      on: {
        "click": function($event) {
          menu.onclick(_vm.locals, $event)
        },
        "!mouseover": function($event) {
          return (function (e) { return _vm.calcSubMenuPos(e, menu); })($event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(menu.text) + "\n        "), (menu.hasChild) ? _c('i', {
      staticClass: "el-icon-caret-right"
    }) : _vm._e(), _vm._v(" "), (menu.hasChild) ? _c('ul', {
      class: {
        'ctx-menu': true
      },
      style: (_vm.subMenuPos)
    }, _vm._l((menu.children), function(submenu, i) {
      return _c('li', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (submenu.show),
          expression: "submenu.show"
        }],
        key: i,
        class: {
          'ctx-item': true, checked: submenu.checked
        },
        on: {
          "click": function($event) {
            submenu.onclick(_vm.locals, $event)
          }
        }
      }, [_vm._v(_vm._s(submenu.text))])
    })) : _vm._e()])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a0101e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main.vue
// module id = 8
// module chunks = 0